import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function authHeaders() {
  const token = typeof window !== 'undefined' ? localStorage.getItem('adeeb-token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function StatCard({ label, value, accent = 'amber', icon }) {
  return (
    <div className="admin-card" style={{ display: 'flex', alignItems: 'center', gap: 14, margin: 0, padding: '18px 20px' }}>
      <div style={{
        width: 46, height: 46, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        borderRadius: 12, background: `linear-gradient(135deg, var(--a1), var(--a2))`,
        color: '#1a1207', fontSize: 22, flexShrink: 0,
        ...(accent === 'amber' && { '--a1': '#b8860b', '--a2': '#daa520' }),
        ...(accent === 'sapphire' && { '--a1': '#4a7fd1', '--a2': '#7da4eb' }),
        ...(accent === 'rose' && { '--a1': '#c75d3a', '--a2': '#e76f51' }),
        ...(accent === 'mint' && { '--a1': '#48a88e', '--a2': '#78d2b4' }),
      }}>{icon}</div>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.6rem', color: 'var(--admin-fg-strong)', lineHeight: 1.1 }}>{value}</div>
        <div style={{ fontSize: '0.72rem', letterSpacing: 1.4, textTransform: 'uppercase', color: 'var(--admin-fg-faint)' }}>{label}</div>
      </div>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    let alive = true;
    axios.get('/api/admin/stats', { headers: authHeaders() })
      .then(({ data }) => alive && setStats(data))
      .catch((e) => alive && setErr(e?.response?.data?.message || 'Failed to load stats'));
    return () => { alive = false; };
  }, []);

  return (
    <div className="admin-page">
      <header className="admin-page-head">
        <h1 className="admin-page-title">Dashboard</h1>
        <p className="admin-page-sub">A quick view of the library and inbox.</p>
      </header>

      {err && <div className="admin-toast admin-toast-error">{err}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14, marginBottom: 22 }}>
        <StatCard label="Books"           value={stats?.books ?? '—'}          accent="amber"    icon="📚" />
        <StatCard label="Users"           value={stats?.users ?? '—'}          accent="sapphire" icon="👥" />
        <StatCard label="Admins"          value={stats?.admins ?? '—'}         accent="mint"     icon="🛡️" />
        <StatCard label="Unread messages" value={stats?.messagesUnread ?? '—'} accent="rose"     icon="✉️" />
        <StatCard label="Total ratings"   value={stats?.ratings ?? '—'}        accent="amber"    icon="⭐" />
        <StatCard label="Total plays"     value={stats?.plays ?? '—'}          accent="sapphire" icon="▶" />
      </div>

      <h2 style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--admin-fg-strong)', fontSize: '1.3rem', marginBottom: 12 }}>Shortcuts</h2>
      <div className="admin-tile-grid">
        <Link to="/admin/books"      className="admin-tile">📚 <strong>Books</strong> <span>Edit text, audio, quizzes</span></Link>
        <Link to="/admin/categories" className="admin-tile">🏷️ <strong>Categories</strong> <span>Add, rename, delete</span></Link>
        <Link to="/admin/users"      className="admin-tile">👥 <strong>Users</strong> <span>Search & manage roles</span></Link>
        <Link to="/admin/messages"   className="admin-tile">✉️ <strong>Messages</strong> <span>Read the contact inbox</span></Link>
        <Link to="/admin/ratings"    className="admin-tile">⭐ <strong>Ratings</strong> <span>Moderate reviews</span></Link>
      </div>
    </div>
  );
}
